import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import {
  CpBody01Primary,
  CpBody02Primary,
  CpBody03Placeholder,
  CpHeading03Primary,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpSectionWrapper } from '../../common';
import { CpFaqVariantWidgetProps } from '../cp-faq-types';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-06);
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-03);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-03);
  }
`;

const Title = styled(CpHeading03Primary)`
  margin-bottom: 0;
`;

const Subtitle = styled(CpBody03Placeholder)`
  margin-bottom: 0;
`;

const FaqQuestion = styled(CpBody02Primary)`
  width: 40%;
  margin-bottom: 0;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const FaqAnswer = styled(CpBody01Primary)`
  width: 60%;
  margin-bottom: 0;
  color: var(--cp-text-secondary);

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const QaWrapper = styled.div`
  border-top: 1px solid var(--cp-border-subtle-auto-adjust);
  padding: var(--cp-spacing-07) 0;
  display: flex;
  gap: var(--cp-spacing-11);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-06);
    flex-direction: column;
    padding: var(--cp-spacing-05) 0;
    border-top: 0;
    border-bottom: 1px solid var(--cp-border-subtle-auto-adjsut);
  }
`;

export const CpFaqRow: React.FC<CpFaqVariantWidgetProps> = ({
  data,
  widget,
}) => {
  const { questionsAndAnswers, title, description } = data;
  const background = useGetBackground(widget);

  return (
    <CpSectionWrapper
      background={background}
      className="rl-cp-faq-widget"
      paddingY={
        widget?.widgetDefinition?.styles?.paddingY as number | undefined
      }
      data-builder-mode-full-tile="true"
    >
      <Wrapper>
        <TitleWrapper>
          <Title autoAdjustColor>{title}</Title>
          <Subtitle autoAdjustColor>{description}</Subtitle>
        </TitleWrapper>

        {questionsAndAnswers && _.isArray(questionsAndAnswers) ? (
          questionsAndAnswers.map((qa) => (
            <QaWrapper>
              <FaqQuestion autoAdjustColor>{qa.question}</FaqQuestion>
              <FaqAnswer autoAdjustColor>{qa.answer}</FaqAnswer>
            </QaWrapper>
          ))
        ) : (
          <></>
        )}
      </Wrapper>
    </CpSectionWrapper>
  );
};
